import { ChangeEvent, useState } from 'react'

export const useSearchValue = <TOption>(
  allItems: TOption[],
  setRenderedItems: (items: TOption[]) => void,
  simpleSearch: boolean,
  filterFunction: (item: TOption, searchValue: string) => boolean,
  onSearchChange?: (searchValue: string) => void
) => {
  const [searchValue, setSearchValue] = useState('')

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const searchVal = e.target.value
    setSearchValue(searchVal)
    if (simpleSearch) {
      setRenderedItems(allItems.filter((item) => filterFunction(item, searchVal)))
    }
    if (onSearchChange) {
      onSearchChange(searchVal)
    }
  }

  const clearSearch = (items: TOption[]) => {
    setSearchValue('')
    setRenderedItems(items)
  }

  return {
    searchValue,
    handleSearch,
    setSearchValue,
    clearSearch
  }
}
